import { axios } from '@Root/API'

export const create = (id, payload) => {
	return axios.post(`qualification-award/${id}/qualification-subject`, payload)
}
